export default __webpack_public_path__ + "static/media/keo-isologo.3a189f09.svg";